import { render, staticRenderFns } from "./GCash.vue?vue&type=template&id=5a46631b&scoped=true"
import script from "./GCash.vue?vue&type=script&lang=js"
export * from "./GCash.vue?vue&type=script&lang=js"
import style0 from "./GCash.vue?vue&type=style&index=0&id=5a46631b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a46631b",
  null
  
)

export default component.exports